// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();

InstantSearchResultItemProduct.prototype.compileTemplate = function() {
  if (this.isShow) {
    var searchTerm = Utils.stripHtml(Globals.currentTerm);
    // Product image
    var imageHTML = '';
    if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
      imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
      imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
    }
    // Product title
    var productTitle = this.customizeProductTitle();
    productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
    // SKU
    var skuHTML = '';
    if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
      skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
      skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
    }
    // Vendor
    var vendorHTML = '';
    if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
      vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
      vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
    }
    // Price
    // const priceCurrency = this.data['price_min_' + window.Shopify.currency.active.toLowerCase()]
    const priceCurrency = typeof this.data['price_min_' + window.Shopify.currency.active.toLowerCase()] !== 'undefined' ? this.data['price_min_' + window.Shopify.currency.active.toLowerCase()] : this.data.price_min;
    var priceHTML = `<p class="{{class.searchSuggestion}}-product-price">
      <span class="{{class.searchSuggestion}}-product-regular-price"></span>
      </p>`
    // Open the result item in new tab when selected
    var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

    return this.getTemplate()
      .replace(/{{id}}/g, this.id)
      .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
      .replace(/{{url}}/g, this.url)
      .replace(/{{newTabAttribute}}/g, newTabAttr)
      .replace(/{{itemProductImage}}/g, imageHTML)
      .replace(/{{title}}/g, productTitle)
      .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
      .replace(/{{itemProductSku}}/g, skuHTML)
      .replace(/{{itemProductVendor}}/g, vendorHTML)
      .replace(/{{itemProductPrice}}/, priceHTML)
      .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
      .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
      .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
  } else {
    return '';
  }
}
InstantSearchResultItemProduct.prototype.afterRender = function () {
  if (this.hasOwnProperty("data") && this.data !== null) {
    var data = this.data;
    var priceHtml = this.compileSuggestionProductPrice().replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);
    var _this = this;
    ajaxPrice(data);
  }
};

function ajaxPrice(productData) {
  var activeCurrency = Shopify.currency.active.toUpperCase();
  try {
      // console.log("Almost Good");
      // Use Ajax
      // Set link for ajax
      let productHandleAjax =
        Shopify.routes.root + "products/" + productData.handle + "?view=boost-pfs-prod-prices";
      let requestReg = formRequest(productHandleAjax);
      requestReg
        .then((res_success) => {
          let parse_res_success = JSON.parse(res_success);
          // Render Ajax Data
          var onSale = parse_res_success.compare_at_price_min > parse_res_success.price_min;
          // Format price
          var price = Utils.formatMoney(parse_res_success.price_min,window.moneyFormat);
          var compareAtPrice = "";
          if (parse_res_success.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(parse_res_success.compare_at_price_min,window.moneyFormat);
            if (Settings.getSettingValue("search.removePriceDecimal")) {
              price = Utils.removeDecimal(price);
              compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
          }
          // console.log(parse_res_success.price)

          // Build Price
          var result = "";
          if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
            if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
              result =
                '<span class="{{class.searchSuggestion}}-product-sale-price boost-pfs-fix-price">{{regularPrice}}</span>&nbsp;<s>{{compareAtPrice}}</s>';
            } else {
              result = '<span class="{{class.searchSuggestion}}-product-regular-price boost-pfs-fix-price">{{regularPrice}}</span>';
            }
          }
          result = result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice)
            .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);
          if (
            jQ(
              '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                productData.id +
                '"] .' +
                Class.searchSuggestion +
                "-product-price",
            )
          ) {
            jQ(
              '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                productData.id +
                '"] .' +
                Class.searchSuggestion +
                "-product-price",
            ).html(result);
          }
        })
        .catch((res_error) => {
          console.error(res_error);
        });

  } catch (e) {}
}

function formRequest(value) {
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", value);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = () => resolve(xhr.responseText);
    xhr.onerror = () => reject(xhr.statusText);
    xhr.send();
  });
}
